import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import 'bulma/css/bulma.css';
import './css/animation.css';
import AppBar from './components/AppBar';
import Auth from './components/Auth';
import Main from './components/Main';
import Callback from './components/Callback';
import AllowCalendarAccess from './components/AllowCalendarAccess';
import Tutorial from './components/Tutorial';

class App extends React.Component {
  state = {
    callbackUrl: '',
    refreshToken: ''
  };

  render() {
    const marginTop = {
      marginTop: '20px'
    };
    return (
      <div>
        <Switch>
          <Route path={'/tutorial'} render={props => <Tutorial />} />
          <Route
            path={'/allowcalendaraccess'}
            render={props => (
              <AllowCalendarAccess
                {...props}
                callbackUrl={this.state.callbackUrl}
                setCallbackUrl={this.handleSetCallbackUrl}
              />
            )}
          />
          <Route
            path={'/callback'}
            render={props => {
              return (
                <Callback
                  search={props.location.search}
                  refreshToken={this.state.refreshToken}
                  setRefreshToken={this.handleRefreshToken}
                />
              );
            }}
          />
          <Auth refreshToken={this.state.refreshToken}>
            <Route
              path={'/'}
              render={props => (
                <div>
                  <section className="hero is-primary is-medium">
                    <div className="container">
                      <AppBar path="/" />
                    </div>
                  </section>
                  <section>
                    <div className="container" style={marginTop}>
                      <Main {...props} refreshToken={this.state.refreshToken} />
                    </div>
                  </section>
                </div>
              )}
            />
          </Auth>
        </Switch>
      </div>
    );
  }

  private handleSetCallbackUrl = (callbackUrl: string): void => {
    this.setState({
      callbackUrl
    });
  };

  private handleRefreshToken = (refreshToken: string): void => {
    this.setState({
      refreshToken
    });
  };
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx